// extracted by mini-css-extract-plugin
export default {"menuWrapper":"BlogTippy_menuWrapper__Rm7xu","menuItem":"BlogTippy_menuItem__4-xM1"};